module.exports = __webpack_public_path__ + "78cafeae48254ef67f3f9a0ae03bd76c.woff2";